<template>
  <v-container style="max-width: 100%">
    <v-tabs
      v-model="activeTabPlacements"
      background-color="transparent"
      color="basil"
      grow
      @change="selectedReservation=[]"
    >
      <v-tab
        v-for="itemTab in itemsTab"
        :key="itemTab"
      >
        <span class="ppc_darkgreen--text">
          {{ itemTab }}
        </span>
      </v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="activeTabPlacements">
      <v-tab-item>
        <span class="d-flex flex-column">
          <v-row justify="center">
            <div class="d-flex flex-row flex-wrap px-2 pt-4 mb-2">
              <v-radio-group
                v-model="scopeResourcesPlanned"
                row
                class="mt-4 d-flex flex-column"
                @change="changeScopeResources()"
              >
                <div class="d-flex flex-row flex-wrap">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-center">
                      <v-radio
                        label="Ongoing"
                        value="ongoing"
                        class="my-0 py-0"
                      />
                    </div>
                    <v-divider class="my-2" />
                    <div class="d-flex flex-row flex-wrap">
                      <div class="d-flex flex-row flex-wrap">
                        <v-radio
                          label="Not Confirmed"
                          value="notConfirmed"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="To be planned"
                          value="notPlaced"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="Pending"
                          value="pending"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="Set"
                          value="set"
                          class="my-0 py-0"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mx-2">
                    <v-radio
                      label="Completed"
                      value="completed"
                      class="my-0 py-0"
                    />
                  </div>
                </div>
              </v-radio-group>
              <v-card
                flat
                outlined
                class="d-flex flex-row flex-wrap my-4"
              >
                <v-card-title>Starting</v-card-title>
                <span class="mx-2 my-0">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="100%"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="between"
                        v-bind="attrs"
                        prepend-icon="$vuetify.icons.icon_mdi_calendar"
                        :value="formattedDate(scopeDates.start)"
                        clearable
                        readonly
                        v-on="on"
                        @click:clear="scopeDates.start = null, resourcesScope = filterResources(resources)"
                      />
                    </template>
                    <v-date-picker
                      v-model="scopeDates.start"
                      no-title
                      scrollable
                      @change="resourcesScope = filterResources(resources)"
                    />
                  </v-menu>
                </span>
                <span class="mx-2 my-0">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="100%"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="and"
                        v-bind="attrs"
                        prepend-icon="$vuetify.icons.icon_mdi_calendar"
                        :value="formattedDate(scopeDates.end)"
                        clearable
                        readonly
                        v-on="on"
                        @click:clear="scopeDates.end = null, resourcesScope = filterResources(resources)"
                      />
                    </template>
                    <v-date-picker
                      v-model="scopeDates.end"
                      no-title
                      scrollable
                      @change="resourcesScope = filterResources(resources)"
                    />
                  </v-menu>
                </span>
              </v-card>
            </div>
          </v-row>

          <v-data-table
            v-if="resourcesScope.length > 0"
            v-model="selectedReservation"
            :headers="headersResourcesScope"
            :items="resourcesScope"
            sort-by="start"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [itemsPerPage]
            }"
            :search="searchResourcesScope"
            show-select
            :single-select="selectedReservationSingleSelect"
            @input="selectResourceReservation"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <div class="d-flex flex-row flex-wrap justify-center">
                  <v-card flat>
                    <v-text-field
                      v-model="searchResourcesScope"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ resourcesScope.length }` + ' resource(s)'"
                      single-line
                      hide-details
                      style="width: 300px"
                      clearable
                    />
                  </v-card>
                </div>
                <v-spacer />
                <!-- <v-btn
                                    :disabled="selectedReservation.length < 2"
                                    @click="multipleEditResources = true, openDialogEditResource(selectedReservation[0].id)"
                                >
                                    Edit Resources
                                </v-btn> -->
                <v-checkbox
                  v-model="sendPassports"
                  class="mt-4 mx-4"
                  label="attach passports"
                />
                <v-btn
                  :disabled="selectedReservation.length === 0"
                  @click="makeReservation"
                >
                  Make Reservation
                </v-btn>
              </v-toolbar>
            </template>

            <template v-slot:[`item.full_name`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex flex-row align-center">
                    <v-btn 
                      x-small
                      fab
                      v-bind="attrs"
                      class="mr-3" 
                      v-on="on"
                      @click="goClient(item.client_id, item.id)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <strong>{{ item.full_name }}</strong>
                  </div>
                </template>
                <span>Go to Client</span>
              </v-tooltip>
            </template>
            
            <template v-slot:[`item.statusPassport`]="{ item }">
              <v-icon
                v-if="`${item.statusPassport}` === 'Approved'"
                small
                color="ppc_darkgreen"
              >$vuetify.icons.icon_mdi_check</v-icon>
            </template>

            <template v-slot:[`item.start`]="{ item }">
              <span v-html="formattedDate(item.start, 'date')" />
            </template>

            <template v-slot:[`item.end`]="{ item }">
              <span v-html="formattedDate(item.end, 'date')" />
            </template>

            <template v-slot:[`item.info_to_provider`]="{ item }">
              <div v-if="item.info_to_provider === null">
                <v-chip
                  small
                  text
                  color="blue darken-2"
                  text-color="white"
                  @click="setDatesMilestones('info_to_provider', item)"
                  :disabled="item.tour_placement_id === null || updatingResource"
                >
                  set
                </v-chip>
              </div>

              <div v-else>
                <v-chip
                  small
                  color="ppc_darkgreen"
                  text-color="white"
                  @click="item.info_to_provider = null; item.reserved = null; item.info_to_client = null; insertUpdateResource(item)"
                  :disabled="item.tour_placement_id === null || updatingResource"
                >
                  {{ formattedDate(item.info_to_provider, 'date') }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.reserved`]="{ item }">
              <div v-if="item.reserved === null">
                <v-chip
                  small
                  text
                  color="blue darken-2"
                  text-color="white"
                  @click="setDatesMilestones('reserved', item)"
                  :disabled="item.tour_placement_id === null || updatingResource"
                >
                  set
                </v-chip>
              </div>

              <div v-else>
                <v-chip
                  small
                  color="ppc_darkgreen"
                  text-color="white"
                  @click="item.reserved = null; item.info_to_client = null; insertUpdateResource(item)"
                  :disabled="item.tour_placement_id === null || updatingResource"
                >
                  {{ formattedDate(item.reserved, 'date') }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.info_to_client`]="{ item }">
              <div v-if="item.info_to_client === null">
                <v-chip
                  small
                  text
                  color="blue darken-2"
                  text-color="white"
                  @click="setDatesMilestones('info_to_client', item)"
                  :disabled="item.tour_placement_id === null || updatingResource"
                >
                  set
                </v-chip>
              </div>

              <div v-else>
                <v-chip
                  small
                  color="ppc_darkgreen"
                  text-color="white"
                  @click="item.info_to_client = null; insertUpdateResource(item)"
                  :disabled="item.tour_placement_id === null || updatingResource"
                >
                  {{ formattedDate(item.info_to_client, 'date') }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.statusResourceId`]="{ item }">
              <v-chip
                :color="getStatusResource(item.statusResourceId).color"
                text-color="white"
                v-html="getStatusResource(item.statusResourceId).name"
              />
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="multipleEditResources = false, openDialogEditResource(item.id)"
                    :disabled="updatingResource"
                  >
                    $vuetify.icons.icon_mdi_pencil
                  </v-icon>
                </template>
                <span>Edit Resource</span>
              </v-tooltip>
            </template>

          </v-data-table>
        </span>

        <v-dialog
          v-model="dialogEditResource"
          max-width="640px"
          persistent
        >
          <v-card
            class="d-flex flex-row flex-wrap"
            color="blue lighten-2"
          >
            <v-card
              flat
              class="d-flex flex-row flex-wrap justify-space-between"
              color="blue lighten-2"
              style="width: 100%"
            >
              <div>
                <v-card-title>
                  <span class=" white--text">Tour Placement #{{ resourceEdit.number_type }} - {{ resourceEdit.full_name }}</span> 
                </v-card-title>
              </div>
            </v-card>
            <div
              class="d-flex flex-column"
              color="blue lighten-2"
              style="max-width: 320px"
            >
              <v-card-text>
                <v-select
                  v-model="resourceEdit.tour_id"
                  :items="listTours"
                  item-text="tourName"
                  item-value="tour_id"
                  :menu-props="{ auto: true }"
                  label="Tour"
                  validate-on-blur
                  clearable
                  color="white"
                  item-color="blue"
                  :disabled="resourceEdit.transaction_id !== null"
                  @click:clear="resourceEdit.tour_placement_id = null"
                  @change="resourceEdit.tour_placement_id = null, resourceEdit.payment = null"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.tourName }}</span>
                  </template>
                </v-select>
                <v-select
                  v-model="resourceEdit.tour_placement_id"
                  :items="filteredPlacements"
                  item-text="organisation"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Organisation"
                  validate-on-blur
                  clearable
                  color="white"
                  item-color="blue"
                  :disabled="resourceEdit.tour_id === null || resourceEdit.transaction_id !== null"
                  @change="changePlacement($event)"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.organisation }}</span>
                  </template>
                </v-select>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="from"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourceEdit.start)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      v-on="on"
                      @click:clear="resourceEdit.start = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourceEdit.start"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="until"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourceEdit.end)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      v-on="on"
                      @click:clear="resourceEdit.end = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourceEdit.end"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
              </v-card-text>
              <v-textarea
                v-model="resourceEdit.comments"
                class="rounded-xl ml-2"
                auto-grow
                clearable
                counter="255"
                outlined
                color="white"
                label="Comments (255 max)"
                :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
              />
            </div>
            <div
              class="d-flex flex-column"
              color="blue lighten-2"
              style="max-width: 320px"
            >
              <v-card-text class="d-flex flex-column">
                <div class="d-flex flex-row flex-wrap">
                  <span>Cost: {{ resourceEdit.currency }}</span>
                  <span>
                    <v-text-field
                      v-model="resourceEditPayment"
                      class="text-input-white"
                      color="white"
                    />
                  </span>
                  <div
                    v-if="resourceEdit.tour_placement_id"
                    class="white--text mb-4"
                  >
                    {{ getPlacementComments }}
                  </div>
                </div>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Info to agency"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourceEdit.info_to_provider)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resourceEdit.tour_placement_id === null"
                      v-on="on"
                      @click:clear="resourceEdit.info_to_provider = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourceEdit.info_to_provider"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Confirmed"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourceEdit.reserved)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resourceEdit.tour_placement_id === null"
                      v-on="on"
                      @click:clear="resourceEdit.reserved = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourceEdit.reserved"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Info to client"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourceEdit.info_to_client)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resourceEdit.tour_placement_id === null"
                      v-on="on"
                      @click:clear="resourceEdit.info_to_client = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourceEdit.info_to_client"
                    no-title
                    scrollable
                    color="blue"
                    @change="checkResourceDates()"
                  />
                </v-menu>
                <v-btn
                  v-if="resourceEdit.transaction_id !== null"
                  color="blue lighten-3"
                  class="ma-4"
                  @click="openTransactionOutgoings(resourceEdit.transaction_id)"
                >
                  <v-icon color="white">
                    $vuetify.icons.icon_mdi_credit_card
                  </v-icon>
                  <span class="white--text">Open Transaction</span>
                </v-btn>
              </v-card-text>
            </div>
            <v-card-actions
              class="d-flex flex-row flex-wrap justify-space-between"
              color="blue lighten-2"
              style="width: 100%"
            >
              <span class="caption black--text">
                service - resource nr: {{ resourceEdit.service_id }} - {{ resourceEdit.id }}
              </span>
              <span>
                <v-btn
                  color="white"
                  text
                  @click="dialogEditResource = false"
                >Cancel</v-btn>
                <v-btn
                  color="white"
                  text
                  @click="insertUpdateResource(resourceEdit), dialogEditResource = false"
                >Save</v-btn>
              </span>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          v-if="resourcesToBePaidScope.length > 0"
          :headers="headersResourcesNotPaid"
          :items="resourcesToBePaidScope"
          v-model="selectedNotPaid"
          sort-by="start"
          class="elevation-1"
          group-by="organisation"
          disable-sort
          :items-per-page="-1"
          disable-pagination
          hide-default-footer
          show-select
          :single-select="selectResourceNotPaidSingleSelect"
          :search="searchResourcesScope"
          @input="selectResourceNotPaid"
          @toggle-select-all="selectResourceNotPaid"
        >
          <template v-slot:top>
            <v-toolbar
              flat
              color="white"
            >
              <v-toolbar-title>Agencies to be Paid</v-toolbar-title>
              <v-spacer />
              <div class="d-flex flex-row flex-wrap justify-center">
                <v-card flat>
                  <v-text-field
                    v-model="searchResourcesScope"
                    append-icon="$vuetify.icons.icon_mdi_magnify"
                    :label="'Search ' + `${ resourcesScope.length }` + ' resource(s)'"
                    single-line
                    hide-details
                    style="width: 300px"
                    clearable
                  />
                </v-card>
              </div>
              <v-spacer />
              <div>
                Total: {{ sumPaymentsAgencyUSDFormatted }} USD -
                {{ sumPaymentsAgencyPENFormatted }} PEN
              </div>
              <v-btn
                small
                :disabled="selectedNotPaid.length === 0"
                class="mx-2"
                @click="payAgency()"
              >
                Pay Agency
              </v-btn>
              <v-btn
                small
                :disabled="selectedNotPaid.length === 0"
                class="mx-4"
                @click="createAgencyReport()"
              >
                send report  
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`group.header`]="{items}">
            <th colspan="10">
              <div class="d-flex flex-row ma-4">
                <h3>
                  {{ items[0].organisation }}
                </h3>
              </div>
            </th>
          </template>

          <template v-slot:[`item.payment`]="{ item }">
            <span v-if="hasMoney(item.payment)">
              {{ item.currency }} {{ formatMoney(item.payment) }}
            </span>
          </template>

          <template v-slot:[`item.paymentOpen`]="{ item }">
            <span v-if="hasMoney(item.paymentOpen)">
              {{ item.currency }} {{ formatMoney(item.paymentOpen) }}
            </span>
          </template>

          <template v-slot:[`item.full_name`]="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  small 
                  rounded 
                  v-bind="attrs"
                  v-on="on" 
                  @click="goClient(item.client_id, item.id)"
                >
                  {{ item.full_name_short }}
                </v-btn>
              </template>
              <span>{{ item.full_name }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.start`]="{ item }">
            {{ formattedDate(item.start) }}
          </template>
          <template v-slot:[`item.end`]="{ item }">
            {{ formattedDate(item.end) }}
          </template>
          <template v-slot:[`item.statusResourceId`]="{ item }">
            <v-chip
              :color="getStatusResource(item.statusResourceId).color"
              text-color="white"
              v-html="getStatusResource(item.statusResourceId).name"
            />
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="openDialogEditResourcePayments(item.id)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <div class="d-flex flex-row flex-wrap">
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            class="white--text my-7 mx-2"
            @click="$router.push({ name: 'Tours'})"
          >
            Tours
          </v-btn>
        </div>
        <v-data-table
          :headers="headersTourAgencies"
          :items="updatedTourPlacements"
          class="elevation-1"
          :items-per-page="-1"
          disable-pagination
          hide-default-footer
          :search="searchTourPlacements"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <div class="d-flex flex-row flex-wrap justify-center">
                <v-card flat>
                  <v-text-field
                    v-model="searchTourPlacements"
                    append-icon="$vuetify.icons.icon_mdi_magnify"
                    :label="'Search ' + `${ updatedTourPlacements.length }` + ' Tour Placement(s)'"
                    single-line
                    hide-details
                    style="width: 300px"
                    clearable
                  />
                </v-card>
              </div>
              <v-spacer />
              <v-btn
                color="ppc_pink"
                dark
                small
                absolute
                right
                fab
                @click="dialog=true"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ item.tourName }} - {{ item.organisation }}
          </template>
          <template v-slot:[`item.payment`]="{ item }">
            {{ item.currency }} {{ item.payment }}
          </template>
          <template v-slot:[`item.contact`]="{ item }">
            {{ item.contact }}
            <v-btn
              v-if="item.contact" 
              fab 
              color="ppc_pink"
              height="20px"
              width="20px"
              right
              top
              class="ml-3"
              @click="openContactInfo(item)"
            >
              <v-icon color="white">
                $vuetify.icons.icon_mdi_information_variant
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.obsolete`]="{ item }">
            <v-icon
              v-if="item.obsolete !== null"
              small
              color="ppc_pink"
            >
              $vuetify.icons.icon_mdi_cancel
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
            >
              $vuetify.icons.icon_mdi_delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="dialog"
      max-width="500px"
      persistent
    >
      <v-form ref="dialogForm">
        <v-card>
          <v-card-title class="ppc_darkgreen darken-1">
            <span class="headline white--text"> {{ formTitle }} {{ editedItem.organisation }} </span>
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="editedItem.tour_id"
              :items="selectTours"
              item-text="name"
              item-value="id"
              :menu-props="{ auto: true }"
              label="Select tour"
              prepend-icon="$vuetify.icons.icon_tours"
              single-line
              validate-on-blur
              clearable
            />
            <v-select
              v-model="editedItem.organisation_id"
              :items="selectOrganisations"
              item-text="name"
              item-value="id"
              :menu-props="{ auto: true }"
              label="Select Organisation"
              single-line
              prepend-icon="$vuetify.icons.icon_mdi_account_group ppc_darkgreen--text"
              validate-on-blur
              clearable
            />
            <div class="d-flex flex-row flex-wrap justify-space-between">
              <v-radio-group
                v-model="editedItem.currency"
                row
                label="Currency"
                :rules="inputRulesReq"
              >
                <v-radio
                  label="$"
                  value="$"
                />
                <v-radio
                  label="PEN"
                  value="S/."
                />
              </v-radio-group>
              <v-text-field
                v-model="editedItem.payment"
                label="Payment"
                class="mr-2"
                style="max-width: 200px"
              />
            </div>
            <div class="d-flex flex-row justify-space-around">
              <v-select
                v-model="editedItem.payment_type"
                :items="payment_types"
                item-text="text"
                item-value="value"
                :menu-props="{ auto: true }"
                label="Payment Type"
                single-line
                validate-on-blur
                clearable
                style="max-width: 200px"
              />
            </div>
            <v-textarea
              v-model="editedItem.comments"
              class="rounded-xl ma-3"
              auto-grow
              clearable
              counter="255"
              outlined
              label="Comments (255 max)"
              :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
            />
            <v-checkbox
              v-model="editedItem.obsolete"
              :input-value="editedItem.obsolete !== null"
              label="Not active"
              @change="setObsolete($event)"
            />
            <v-text-field
              v-if="editedItem.obsolete !== null"
              :value="formattedDate(editedItem.obsolete)"
              disabled
              label="From"
              class="ml-2"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="close"
            >
              Cancel
            </v-btn>
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="savePlacement"
            >
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Are you sure you want to delete {{ editedItem.name }}?</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="closeDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogContactInfo"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="ppc_darkgreen darken-1">
          <span class="headline white--text"> {{ contact.name }} </span>
        </v-card-title>
        <v-card-subtitle
          v-if="contact.organisation"
          class="mt-5"
        >
          <v-icon
            class="mr-2"
          >
            $vuetify.icons.icon_mdi_domain ppc_darkgreen--text
          </v-icon>
          <span class="font-weight-bold">{{ contact.organisation }}</span>
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col
              v-if="contact.address || contact.country"
              cols="12"
            >
              <v-icon
                class="mr-2"
              >
                $vuetify.icons.icon_mdi_map_marker ppc_darkgreen--text
              </v-icon>
              {{ contact.address }}
              <span v-if="contact.address && contact.country">,</span>
              {{ contact.country }}
            </v-col>
                        
            <v-col
              v-if="contact.phone"
              cols="12"
              sm="6"
            >
              <v-icon
                class="mr-2"
              >
                mdi-cellphone ppc_darkgreen--text
              </v-icon>
              {{ contact.phone }}
            </v-col>
            <v-col
              v-if="contact.phone_alt"
              cols="12"
              sm="6"
            >
              <v-icon
                class="mr-2"
              >
                mdi-phone ppc_darkgreen--text
              </v-icon>
              {{ contact.phone_alt }}
            </v-col>
            <v-col
              v-if="contact.email"
              cols="12"
              sm="6"
            >   
              <v-icon
                class="mr-2"
              >
                mdi-email ppc_darkgreen--text
              </v-icon>
              {{ contact.email }}
            </v-col>
            <v-col
              v-if="contact.comments"
              cols="12"
            >   
              <v-icon
                class="mr-2"
              >
                mdi-message-text ppc_darkgreen--text
              </v-icon>
              {{ contact.comments }}
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogContactInfo = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import dayjs from 'dayjs';
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import compare from '../mixins/compare';
import decUtil from '@/utils/decimalUtils';

export default {

    mixins: [inputRules, formattedDate, compare],
    data: () => ({
        itemsTab: [
            'Planning', 'Payments', 'Tours & Agencies'
        ],
        activeTabPlacements: 0,
        decUtil,
      dialog: false,
      dialogDelete: false,
      dialogContactInfo: false,
      dialogEditResource: false,
      headersTourAgencies: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
            { text: 'Payment', value: 'payment' },
            { text: 'Payment Type', value: 'payment_type' },
            { text: 'Comments', value: 'comments' },
            { text: 'Active', value: 'obsolete' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        payment_types: [
            { text: '100% before' , value: '100% before'},
            { text: '100% after' , value: '100% after'},
            { text: '50% - 50%' , value: '50% - 50%'},
            { text: 'other' , value: 'other'},
        ],

        headersResourcesScope: [
            { text: 'Client', value: 'full_name' },
            { text: 'Passport', value: 'statusPassport' },
            { text: 'Food', value: 'food_preference' },
            { text: 'Agency', value: 'agency' },
            { text: 'Tour', value: 'tourName' },
            { text: 'Organisation', value: 'organisation' },
            { text: 'Service', value: 'serviceName' },
            { text: 'Start', value: 'start', width: '120px' },
            { text: 'End', value: 'end', width: '120px' },
            { text: 'Requested', value: 'info_to_provider', width: '100px' },
            { text: 'Reserved', value: 'reserved', width: '100px' },
            { text: 'Info at client', value: 'info_to_client', width: '100px' },
            { text: 'Comments', value: 'comments', width: '200px' },
            { text: 'Status', value: 'statusResourceId' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        headersResourcesNotPaid: [
            { text: 'Tour Agency', value: '' },
            { text: 'Tour', value: 'tourName' },
            { text: 'Payment', value: 'payment' },
            // { text: 'When', value: 'paymentTypeTour' },
            { text: 'Open', value: 'paymentOpen' },
            { text: 'Client', value: 'full_name' },
            { text: 'Start', value: 'start' },
            { text: 'End', value: 'end' },
            { text: 'Status', value: 'statusResourceId' },
            { text: 'Actions', value: 'actions', sortable: false },
      ],
      updatedTourPlacements: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        option_question: '',
        price: 0,
        varPrice: 0,
      },
      defaultItem: {
        name: '',
        option_question: '',
        price: 0,
        varPrice: 0,
      },
      contact: [],
      resources: [],
      resource: [],
      resourceEdit: [],
      resourcesToBePaidDB: [],
      resourcesToBePaidScope: [],
      loadingButtonCompletedTours: false,
      resourcesCompleted: [],
      selectedNotPaid: [],
      selectResourceNotPaidSingleSelect: true,
      selectedReservation: [],
      selectedReservationSingleSelect: true,
      scopeResourcesPlanned: 'ongoing',
      resourcesScope: [],
      searchResourcesScope: '',
      searchTourPlacements: '',
      sendPassports: false,
      scopeDates: [],
      selectTours: [],
      multipleEditResources: false,
      updatingResource: false,
    }),

    computed: {

        formTitle () {
            return this.editedIndex === -1 ? 'New Placement ' : ''
        },

        selectContacts () {
            return this.$store.state.contacts.filter(function(select_item) {
                return select_item.obsolete === null && select_item.organisation !== null;
            })
        },

        getPlacementComments () {
            if (this.resource.tour_placement_id) {
                let placementId = this.resource.tour_placement_id;
                var placement = this.updatedTourPlacements.filter(function(select_item) {
                    return select_item.id === placementId;
                })[0];
                return placement.comments;
            } else {
                return '';
            }
        },

        progressAdvance () {
            return this.$store.getters.progressAdvance
        },

        reloadResourcesTourAgencies () {
            return this.$store.getters.reloadResourcesTourAgencies
        },

        itemsPerPage () {
            return this.$store.getters.itemsPerPage
        },

        sumPaymentsAgencyUSD() {
            // returns Decimal
            return this.sumPaymentsAgency();
        },

        sumPaymentsAgencyUSDFormatted() {
            return this.decUtil.format(this.sumPaymentsAgencyUSD);
        },

        sumPaymentsAgencyPENFormatted() {
            return this.decUtil.format(
            this.sumPaymentsAgencyUSD.times(
                this.decUtil.toDec(this.$store.state.exchangeRate)
            )
            );
        },

        filteredPlacements() {
            const tourId = this.resourceEdit.tour_id;

            if (!tourId) return [];

            return this.updatedTourPlacements.filter(p =>
                p.tour_id === tourId && p.obsolete === null
            );
        },

        resourceEditPayment: {
            get() {
                return this.decUtil.format(this.decUtil.toDec(this.resourceEdit.payment));
            },
            set(val) {
                this.resourceEdit.payment = this.decUtil.toDec(val);
            }
        },

        selectOrganisations() {
            console.log(this.$store.state.organisations);
            return this.$store.state.organisations;
        },

        listTours () {
            return this.updatedTourPlacements.filter(function(select_item) {
                return select_item.obsolete === null;
            })
        },

    },

    watch: {
        async reloadResourcesTourAgencies(newValue, oldValue) {
            console.log(newValue, oldValue)
            if (this.$store.state.reloadResourcesTourAgencies) {
                this.$store.dispatch('reloadResourcesTourAgencies', false);
                await this.getResources();
            }
        },
    },

    beforeCreate () {
        if (this.$store.state.accessTours === 0) {
            this.$router.push({ name: 'Illegal' })
        }
        // this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
      this.initialize();
    },

    methods: {
      async initialize () {
        let previousView =  this.$store.state.breadcrumbs[this.$store.state.breadcrumbs.length - 1];
        let breadcrumbs =  JSON.parse(JSON.stringify(this.$store.state.breadcrumbs));
        if (previousView === 'Tours') {
          this.activeTabPlacements = 2;
          breadcrumbs.slice(-1);
        }
        if (previousView === 'TourAgenciesReport') {
            this.activeTabPlacements = 1;
            breadcrumbs.slice(-1);
        }
        breadcrumbs = ['TourAgencies'];
        await this.$store.dispatch('breadcrumbs', breadcrumbs);

        // var date = new Date();
        // let start = date.getTime();
        // console.log('initialize ***1');

        this.$store.dispatch('getOrganisations');

        this.updatedTourPlacements = JSON.parse(JSON.stringify(await this.$store.dispatch('getTourPlacements')));
        for (let index = 0; index < this.updatedTourPlacements.length; index++) {
            (this.updatedTourPlacements[index].obsolete) ? this.updatedTourPlacements[index].obsolete = this.formattedDate(this.updatedTourPlacements[index].obsolete, 'date') : this.updatedTourPlacements[index].obsolete = null;
        }
        this.updatedAvailableTours = JSON.parse(JSON.stringify(await this.$store.dispatch('getTours')));
        for (let index = 0; index < this.updatedAvailableTours.length; index++) {
            (this.updatedAvailableTours[index].obsolete) ? this.updatedAvailableTours[index].obsolete = this.formattedDate(this.updatedAvailableTours[index].obsolete, 'date') : this.updatedAvailableTours[index].obsolete = null;
        }
        let toursNotObsolete = this.updatedAvailableTours.filter(function(select_item) {
            return select_item.obsolete === null;
        })
        this.selectTours = toursNotObsolete.sort(this.dynamicSort('name'));

        await this.getResources();

        if (this.$route.params.resourceId) {
            let resourceId = this.$route.params.resourceId;
            this.openDialogEditResource(resourceId);
            this.$route.params.resourceId = null;
        }
        
        // date = new Date();
        // let end = date.getTime();
        // let totalTime = ((end-start)/1000);
        // console.log('initialize ***2', totalTime);

        this.$store.dispatch('setLoadingApp', 0)
      },

        hasMoney(val) {
            if (val === null || val === undefined) return false;

            // Decimal
            if (val && val.constructor?.name === 'Decimal') {
                return !val.isZero();
            }

            // Reject objects
            if (typeof val === 'object') return false;

            return !this.decUtil.toDec(val).isZero();
        },

        formatMoney(val) {
            if (val === null || val === undefined) return '';
            if (val && val.constructor?.name === 'Decimal') {
                return this.decUtil.format(val);
            }
            if (typeof val === 'object') return '';
            return this.decUtil.format(val);
        },

      async getResources() {
        this.$store.dispatch('setLoadingApp', 1);
        if (this.scopeResourcesPlanned === 'completed') {
            this.resources = await this.$store.dispatch('getResourcesAllTours');
        } else {
            this.resources = await this.$store.dispatch('getResourcesConfirmedNotCompletedTours');
        }
        this.resources = this.prepareResources(this.resources);

        this.filterResourcesToBePaid();

        if (this.scopeResourcesPlanned === 'completed') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId === 1 || select_item.statusResourceId === 15;
            });
        } else if (this.scopeResourcesPlanned === 'ongoing') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId !== 1 && select_item.statusResourceId !== 15;
            });
        } else if (this.scopeResourcesPlanned === 'notPlaced') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId !== 1 && select_item.statusResourceId !== 2 && select_item.statusResourceId !== 8 && select_item.statusResourceId !== 15 && (select_item.tour_placement_id === null || (select_item.tour_placement_id !== null && select_item.info_to_provider === null));
            });
        } else if (this.scopeResourcesPlanned === 'pending') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId === 6;
            });
        } else if (this.scopeResourcesPlanned === 'notConfirmed') {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId === 8;
            });
        } else {
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.statusResourceId === 4; // all set
            });
        }
        
        this.$store.dispatch('setLoadingApp', 0);
      },

      filterResourcesToBePaid() {

        this.resourcesToBePaidDB = this.resources.filter(function(select_item) {
            return (select_item.statusResourceId === 2 || select_item.statusResourceId === 3 || select_item.statusResourceId === 4 || select_item.statusResourceId === 5 || select_item.statusResourceId === 6 || select_item.statusResourceId === 7 || (select_item.statusResourceId === 8 && select_item.start !== null)) && select_item.tour_placement_id !== null && select_item.paymentOpen > 0.05;
        });
        this.resourcesToBePaidDB.sort(this.dynamicSort('organisation'));
        this.resourcesToBePaidScope = this.resourcesToBePaidDB;

      },

    prepareResources(resources) {

        for (const r of resources) {

            // --------------------
            // Dates
            // --------------------
            r.start = r.start ? this.formattedDate(r.start, 'date') : null;
            r.end = r.end ? this.formattedDate(r.end, 'date') : null;
            r.info_to_client = r.info_to_client
            ? this.formattedDate(r.info_to_client, 'date')
            : null;
            r.info_to_provider = r.info_to_provider
            ? this.formattedDate(r.info_to_provider, 'date')
            : null;
            r.reserved = r.reserved
            ? this.formattedDate(r.reserved, 'date')
            : null;

            if (r.statusResourceId === 9) {
            r.isSelectable = false;
            }

            // --------------------
            // Tour name
            // --------------------
            const tour = this.updatedAvailableTours.find(t => t.id === r.tour_id);
            if (tour) {
            r.tourName = tour.name;
            }

            // --------------------
            // Organisation / contact
            // --------------------
            const placement = this.updatedTourPlacements.find(
            p => p.id === r.tour_placement_id
            );
            if (placement) {
            r.organisation = placement.organisation;
            r.contact_id = placement.contact_id;
            }

            // --------------------
            // paymentOpen (CANONICAL)
            // --------------------
            const payment = this.decUtil.toDec(r.payment ?? 0);
            const paid = this.decUtil.toDec(r.amountPaidReceiver ?? 0);

            // keep as Decimal (no formatting here)
            // r.paymentOpen = payment.minus(paid);
            r.paymentOpen = payment.minus(paid).toString();
        }

        return resources;

    },

      filterResources(resources) {
        if (this.scopeDates.start || this.scopeDates.end) {
            let start = this.scopeDates.start;
            let end = this.scopeDates.end;
            if (this.scopeDates.start && this.scopeDates.end && this.scopeDates.start > this.scopeDates.end) {
                this.$store.dispatch('errorMessage', 'between earlier please');
                return resources;
            }
            if (this.scopeDates.start) {
                resources = resources.filter(function(select_item) {
                    return select_item.start >= start;
                });
            }
            if (this.scopeDates.end) {
                resources = resources.filter(function(select_item) {
                    return select_item.start <= end;
                });
            }
        } 
        return resources;
      },

      selectResourceNotPaid(event) {
        let countIsSelectable = this.resourcesToBePaidScope.filter(function(select_item) {
            return select_item.isSelectable;
        });
        // console.log(event.value, this.selectedNotPaid.length, countIsSelectable.length, this.resourcesToBePaidScope)
        if (this.selectedNotPaid.length === 0 || (event.value && this.selectedNotPaid.length === countIsSelectable.length)) {
            this.selectResourceNotPaidSingleSelect = true;
            this.selectedNotPaid = [];
            this.resourcesToBePaidScope.map( (x) => x.isSelectable = true );
            return;
        } else {
            this.selectResourceNotPaidSingleSelect = false;
            for (let i = 0; i < this.resourcesToBePaidScope.length; i++) {
                if (this.selectedNotPaid[0].organisation === this.resourcesToBePaidScope[i].organisation) {
                    this.resourcesToBePaidScope[i].isSelectable = true;
                } else {
                    this.resourcesToBePaidScope[i].isSelectable = false;
                }
            }
        }
        
      },

      async selectResourceReservation() {
        if (this.selectedReservation.length === 0) {
            await this.getResources();
            this.selectedReservationSingleSelect = true;
            return;
        } else {
            let tour_placement_id = this.selectedReservation[0].tour_placement_id;
            let start = this.selectedReservation[0].start;
            this.selectedReservationSingleSelect = false;
            this.resourcesScope = this.resources.filter(function(select_item) {
                return select_item.tour_placement_id === tour_placement_id && select_item.start === start;
            });
          }
        },

        async makeReservation() {
            let attachments = [];
            let passportIncluded = false;
            let preferenciaAlimentaria = false;
            let emailIntro = "Estimado " + this.selectedReservation[0].organisation + ",\n\n" + 
            "Presentamos la(s) nueva(s) reserva(s). Por favor, confirmar lo mas rápido posible.\n\n"
            emailIntro += "Tour: " + this.selectedReservation[0].tourName + "\n";
            emailIntro += "Fecha de salida: " + this.selectedReservation[0].start + "\n";
            emailIntro += "Fecha de retorno: " + this.selectedReservation[0].end + "\n";
            emailIntro += "Pax: " + this.selectedReservation.length + "\n";
            emailIntro += "Nombres: ";
            for (let i = 0; i < this.selectedReservation.length; i++) {
                (i > 0) ? emailIntro += ", " : emailIntro += ""
                emailIntro += this.selectedReservation[i].full_name;
                if (this.selectedReservation[i].food_preference === 'not known' || this.selectedReservation[i].food_preference === null) {
                    emailIntro += ' (*)';
                    preferenciaAlimentaria = true;
                } else if (this.selectedReservation[i].food_preference === 'I am vegan') {
                    emailIntro += ' (vegano)'
                } else if (this.selectedReservation[i].food_preference === 'I am vegetarian') {
                    emailIntro += ' (vegetariano)'
                }
                if (this.sendPassports) {
                    await this.$store.dispatch('getUploads', this.selectedReservation[i].client_id);
                    let passport = this.$store.state.uploadInfos.filter(function(select_item) {
                        return select_item.type === 'passport';
                    });
                    if (passport.length === 1) {
                        passportIncluded = true;
                        let content = await this.$store.dispatch('createAttachments', passport[0].id);
                        attachments.push(
                            {   
                                filename: passport[0].name,
                                path: content,
                            },
                        );
                    }
                }
            }
            emailIntro += "\n\n";
            if (preferenciaAlimentaria) {
                emailIntro += "(* = preferencia alimentaria no conocido)";
                emailIntro += "\n\n\n";
            }
            // emailIntro += "Idiomas: Ingles/Español" + "\n";
            // emailIntro += "Almuerzo: incluido" + "\n";
            // emailIntro += "Ingreso: incluido" + "\n\n";
            if (passportIncluded) {
                emailIntro += "Pasaportes estan aumentado." + "\n\n";
            }
            emailIntro += "Saludos cordiales, \n\n" + this.$store.state.user + "\n\n" +
            "office@proyectoperucentre.org\n" +
            "Proyecto Peru Centre\n" +
            "Avenida Arcopata 466-A\n" +
            "Cusco, Cusco, 45\n" +
            "+ 51 84 240 278"
            let payload = {
                submittedFrom: "TourAgencies",
                emailList: this.selectedReservation[0].organisationEmail,
                // emailList: 'mail4coen@gmail.com',
                emailSubject: "Reservación",
                emailIntro: emailIntro,
                messageHTML: '',
                messagePlain: '',
                openEmailDialog: true,
                saveInvoice: false,
                teacherId: null,
                resourceId: null,
                attachments: attachments,
                resources: this.selectedReservation,
            };
            this.$store.dispatch('emailMessage', payload);
        },
      openContactInfo(editedItem) {
        let tmp = editedItem.contact_id;
        this.contact = this.$store.state.contacts.filter(function(select_item) {
            return select_item.id === tmp;
        })[0]
        this.dialogContactInfo = true;
      },

      editItem (item) {
        this.editedIndex = this.updatedTourPlacements.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem (item) {
        this.editedIndex = this.updatedTourPlacements.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let response = await this.$store.dispatch('deleteTourPlacement', this.editedItem.id)
        if (response.data.affectedRows === 1) {
            this.$store.dispatch('successMessage', 'Tour placement deleted');
        } else {
            this.$store.dispatch('errorMessage', 'Something went wrong');
        }
        this.updatedTourPlacements = JSON.parse(JSON.stringify(await this.$store.dispatch('getTourPlacements')));
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async openDialogEditResource(id) {
        let result = this.resourcesScope.filter(function(select_item) {
            return select_item.id === id;
        });
        // console.log('openDialogEditResource test2', result)
        if (result.length === 0) {
            result = await this.$store.dispatch('getResourceId', id);
            // console.log('openDialogEditResource test3', result)
        } else {
            result = result[0];
        }
        this.resourceEdit = Object.assign({}, result);
        // console.log('openDialogEditResource test4', this.resourceEdit, result)
        this.dialogEditResource = true;
      },

      openDialogEditResourcePayments(id) {
        let result = this.resourcesToBePaidDB.filter(function(select_item) {
            return select_item.id === id;
        })[0];
        this.resourceEdit = Object.assign({}, result);
        this.dialogEditResource = true;
      },

        async insertUpdateResource (resource) {
            this.updatingResource = true;
            let payload = {
                client: null,
                applications: null,
                services: null,
                radioGroups: null,
                radioOptions: null,
                options: null,
                resources: [],
            };
            if (this.multipleEditResources) {
                let tmpResource = Object.assign({}, resource);
                let comments = resource.comments;
                for (let i = 0; i < this.selectedReservation.length; i++) {
                    tmpResource.id = this.selectedReservation[i].id;
                    if (this.selectedReservation[i].comments !== null) {
                        tmpResource.comments = this.selectedReservation[i].comments;
                    } else {
                        tmpResource.comments = comments;
                    }
                    payload.resources.push(tmpResource);
                }
            } else {
                payload.resources.push(resource);
            }
            console.log('insertUpdateResource test1', payload);
            let result = await this.$store.dispatch('insertUpdateMainItems', payload);
            console.log('insertUpdateResource test2', result);
            let resourcesChanged = result.data.resources;
            resourcesChanged = this.prepareResources(resourcesChanged);
            let posResource = null;
            for (let i = 0; i < resourcesChanged.length; i++) {

                posResource = this.selectedReservation.map(function(e) { return e.id; }).indexOf(resourcesChanged[i].id);
                if (posResource > -1) {
                    this.selectedReservation.splice(posResource, 1, JSON.parse(JSON.stringify(resourcesChanged[i])));
                }

                posResource = this.resourcesScope.map(function(e) { return e.id; }).indexOf(resourcesChanged[i].id);
                if (posResource > -1) {
                    this.resourcesScope.splice(posResource, 1, JSON.parse(JSON.stringify(resourcesChanged[i])));
                }

                // posResource = this.resourcesToBePaidDB.map(function(e) { return e.id; }).indexOf(resourcesChanged[i].id);
                // if (posResource > -1) {
                //     this.resourcesToBePaidDB.splice(posResource, 1, JSON.parse(JSON.stringify(resourcesChanged[i])));
                // }

                posResource = this.resources.map(function(e) { return e.id; }).indexOf(resourcesChanged[i].id);
                if (posResource > -1) {
                    this.resources.splice(posResource, 1, JSON.parse(JSON.stringify(resourcesChanged[i])));
                }

            }

            this.filterResourcesToBePaid();
            this.resourcesToBePaidScope = this.resourcesToBePaidDB;
            this.updatingResource = false;

        },

      getStatusResource(id) {
            if (id) {
                return this.$store.state.statusResources.filter((select_item) => {
                    return select_item.id === id;
                })[0];
            } else {
                return [];
            }
        },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async savePlacement () {
          if(this.$refs.dialogForm.validate()){
            let tmpOrgId = this.editedItem.organisation_id;
            let tmpTourId = this.editedItem.tour_id;
            console.log(this.updatedTourPlacements)
            let doubleName = this.updatedTourPlacements.filter(function(select_item) {
                return select_item.organisation_id === tmpOrgId && select_item.tour_id === tmpTourId;
            })
            console.log(doubleName)
            if (doubleName.length > 0 && this.editedIndex !== this.updatedTourPlacements.indexOf(doubleName[0])) {
                this.$store.dispatch('errorMessage', 'The placement "' + doubleName[0].name + '" already exists!');
                return;
            } else {
                await this.$store.dispatch('insertTourPlacement', this.editedItem)
                this.updatedTourPlacements = JSON.parse(JSON.stringify(await this.$store.dispatch('getTourPlacements')));
            }
            this.close()
          }
      },

      goClient(id, resourceId) {
            this.$store.dispatch('setLoadingApp', 1);
            this.$router.push({ name: 'Client', params: { id: id, resourceId: resourceId } })
        },
        setObsolete(event) {
            if (event) {
                this.editedItem.obsolete = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedItem.obsolete = null
            }
            
        },

        changePlacement(event) {
            console.log('changePlacement', event);
            this.resourceEdit.payment = null;
            this.resourceEdit.info_to_provider = null;
            this.resourceEdit.reserved = null;
            this.resourceEdit.info_to_client = null;
            if (event) {
                let tourAgency = this.updatedTourPlacements.filter(function(select_item) {
                    return select_item.id === event;
                })[0];
                this.resourceEdit.currency = tourAgency.currency;
                this.resourceEdit.payment = tourAgency.payment;
            }
        },

        sumPaymentsAgency() {
            const total = this.selectedNotPaid.reduce((sum, item) => {
                const payment = this.decUtil.toDec(item.paymentOpen || 0);

                if (item.currency === '$') {
                    return sum.plus(payment);
                }

                // convert to dollars
                return sum.plus(
                    payment.div(this.decUtil.toDec(item.exchangeRate))
                );
            }, this.decUtil.toDec(0));

            return total;
        },

        async payAgency() {
            this.$store.dispatch('setLoadingApp', 1);

            try {
                const paymentDec = this.sumPaymentsAgency(); // Decimal

                this.$router.push({
                name: 'Financial',
                params: {
                    paymentAgency: paymentDec.toString(), // canonical string, not formatted
                    payInDollars: true,
                    resources: this.selectedNotPaid
                }
                });
            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }
        },

        openTransactionOutgoings(transIdOutgoings) {
            this.$store.dispatch('setLoadingApp', 1)
            this.$router.push({ name: 'Financial', params: { transIdOutgoings: transIdOutgoings } })
        },

        checkResourceDates() {
            if(this.resourceEdit.info_to_provider === null && this.resourceEdit.reserved === null) {
                this.resourceEdit.info_to_provider = this.resourceEdit.info_to_client; 
                this.resourceEdit.reserved = this.resourceEdit.info_to_client;
            }
            if(this.resourceEdit.reserved === null) {
                this.resourceEdit.reserved = this.resourceEdit.info_to_client;
            }
        },

        async createAgencyReport() {
            let payload = {
                report: this.selectedNotPaid,
            }
            await this.$store.dispatch('saveDataForReport', payload);
            this.$router.push({ name: 'TourAgenciesReport'});
        },

        async changeScopeResources() {
            this.$store.dispatch('setLoadingApp', 1)
            await this.getResources();
            this.selectedReservation=[];
        },

        async setInfoToProvider(item) {
          item.info_to_provider = new Date().toISOString()

          await this.insertUpdateResource(item)
        },

        async clearInfoToProvider(item) {
          item.info_to_provider = null
          item.reserved = null
          item.info_to_client = null

          await this.insertUpdateResource(item)
        },

        setDatesMilestones(milestone, item) {

          let date = new Date();
          date = this.formattedDate(date, 'date');

          if (milestone === 'info_to_provider') {
            item.info_to_provider = date;
          }

          if (milestone === 'reserved') {
            console.log('setDatesMilestones reserved', milestone, date)
            item.reserved = date;
            if (item.info_to_provider === null) {
              item.info_to_provider = date;
            }
          }

          if (milestone === 'info_to_client') {
            item.info_to_client = date;
            if (item.info_to_provider === null) {
              item.info_to_provider = date;
            }
            if (item.reserved === null) {
              item.reserved = date;
            }
          }

          this.insertUpdateResource(item);

        },
        
    },
}


</script>
